"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteMembersDefinition = void 0;
const static_service_1 = require("@wix/static-service");
exports.SiteMembersDefinition = (0, static_service_1.defineStaticService)('@wix/viewer-service-site-members');
//# sourceMappingURL=index.js.map